import * as React                       from "react";

import "./subscription-route.scss";

import {cs}                            from "@Common/react/chain-services";
import {SubscriptionsDetails} from "@Xpresso/routes/subscriptions/subscriptions-details";
import {ProfileLayout}       from "../common/profile-layout";

export const AccountSubscriptionRoute = () => cs(
    ({}, next) => ProfileLayout({activeTab: "subscription", next}),
    ["referenceUrl", ({query}, next) => next(
        query?.referrer && query?.id_cart && `/${query.referrer}/${query.id_cart}`
    )],
    ({referenceUrl}) => (
        SubscriptionsDetails({referenceUrl})
    )
);
